import {useDispatch, useSelector} from "react-redux";
import {CustomizationProvider, CustomizationProviderProps} from "@twilio-paste/core/customization";
import {CSSProperties, useEffect} from "react";

import {RootContainer} from "./RootContainer";
import {
  AppState,
  EngagementPhase,
  sessionDataHandler,
  initSession,
  changeEngagementPhase,
  setPreEngagementMessages,
} from "..";

const AnyCustomizationProvider = (props: CustomizationProviderProps & {style: CSSProperties}) => (
  <CustomizationProvider {...props} style={props.style || {}} />
);
const WebchatWidget = () => {
  const theme = useSelector((state: AppState) => state.config.theme);
  const dispatch = useDispatch();

  useEffect(() => {
    const existingSession = sessionDataHandler.tryResumeExistingSession();
    if (existingSession) {
      dispatch(setPreEngagementMessages([]));
      // @ts-ignore
      dispatch(initSession({token: existingSession.token, conversationSid: existingSession.conversation_sid}));
    } else {
      sessionDataHandler.clear();
      dispatch(setPreEngagementMessages([]));
      dispatch(changeEngagementPhase({phase: EngagementPhase.PreEngagementChat}));
    }
  }, [dispatch]);

  return (
    <AnyCustomizationProvider
      baseTheme={theme?.isLight ? "default" : "dark"}
      theme={theme?.overrides}
      elements={{
        MESSAGE_INPUT: {
          boxShadow: "none!important" as "none",
        },
        MESSAGE_INPUT_BOX: {
          display: "inline-block",
          boxShadow: "none",
        },
        ALERT: {
          paddingTop: "space30",
          paddingBottom: "space30",
        },
        BUTTON: {
          "&[aria-disabled='true'][color='colorTextLink']": {
            color: "colorTextLinkWeak",
          },
        },
      }}
      style={{}}
    >
      <RootContainer />
    </AnyCustomizationProvider>
  );
};

export default WebchatWidget;
